"use strict";
var _a;
exports.__esModule = true;
exports.TransactionBehaviorMap = void 0;
var TransactionBaseType_1 = require("./TransactionBaseType");
/**
 * @description Map used to determine the normal behavior of a transaction.
 * An example purpose is being able to identify when a transaction is acting
 * in reverse behavior and thereby allowing us to know the transaction is a reversal.
 * Impact values follow the following rules:
 *  -1: negative impact
 *  0: no impact
 *  1: positive impact
 *
 * Based on https://vestwell.atlassian.net/wiki/spaces/VW3/pages/2734817374/BRD+-+Ledgers#Ledger-Requirements
 */
exports.TransactionBehaviorMap = (_a = {},
    _a[TransactionBaseType_1.TransactionBaseType.Buy] = {
        amountImpact: -1,
        unitsImpact: 1
    },
    _a[TransactionBaseType_1.TransactionBaseType.Sell] = {
        amountImpact: 1,
        unitsImpact: -1
    },
    _a[TransactionBaseType_1.TransactionBaseType.Deposit] = {
        amountImpact: 1,
        unitsImpact: 0
    },
    _a[TransactionBaseType_1.TransactionBaseType.Withdrawal] = {
        amountImpact: -1,
        unitsImpact: 0
    },
    _a[TransactionBaseType_1.TransactionBaseType.IncomeIn] = {
        amountImpact: 1,
        unitsImpact: 0
    },
    _a[TransactionBaseType_1.TransactionBaseType.IncomeOut] = {
        amountImpact: -1,
        unitsImpact: 0
    },
    _a[TransactionBaseType_1.TransactionBaseType.TransferIn] = {
        amountImpact: 0,
        unitsImpact: 1
    },
    _a[TransactionBaseType_1.TransactionBaseType.TransferOut] = {
        amountImpact: 0,
        unitsImpact: -1
    },
    _a[TransactionBaseType_1.TransactionBaseType.Fee] = {
        amountImpact: -1,
        unitsImpact: 0
    },
    _a[TransactionBaseType_1.TransactionBaseType.FeeReversal] = {
        amountImpact: 1,
        unitsImpact: 0
    },
    _a);
